export default [
    {
        path: '/base_hours',
        name: 'base_hours',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Horários Base',
            icon: 'mdi-timeline-text-outline',
            breadcrumbs: [
                { text: 'Lista de Horários Base', disabled: true }
            ]
        }
    }
]